import { Component, Input, OnInit } from '@angular/core';
import { LibraryService } from '@core/services/library/library.service';
import { ModalService } from '@core/services/modal/modal.service';
import { AgendaService } from '@state/agenda/agenda.service';
import { Agenda } from '@state/agenda/agenda.model';
import { AgendaQuery } from '@state/agenda/agenda.query';

@Component({
    selector: 'app-agenda-edit-comments',
    templateUrl: './appointment-edit-comments.modal.html',
    styleUrls: ['./appointment-edit-comments.modal.scss'],
    standalone: false
})
export class AppointmentEditCommentsModal implements OnInit {
    @Input() appointment: Agenda;
    @Input() comments: string;
    @Input() id: string;
    title = this.libraryService.getLabel('lbl_edit_comments');

    constructor(
        private agendaQuery: AgendaQuery,
        private agendaService: AgendaService,
        private libraryService: LibraryService,
        private modalService: ModalService
    ) {
    }

    ngOnInit(): void {
    }

    closeModal(appointment?: Agenda): void {
        this.modalService.dismiss({ appointment }, 'close', this.id);
    }

    async saveComments(): Promise<void> {
        this.modalService.dismiss({ comments: this.comments }, 'close', this.id);
    }
}
